import React from "react";

const HeaderImage = ({ src, alt }) => {
  return (
    <div className="relative w-full h-[200px] rounded-lg z-0 brightness-75">
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover rounded-lg"
      />
    </div>
  );
};

export default HeaderImage;
